import styles from "../styles/components/loaders.module.css";

function TitleLoader() {
  return (
    <div className={styles.container}>
      <div className={styles.entry2}>e1</div>
    </div>
  )
}

export default TitleLoader
